import React, { useEffect, useState } from "react";
import { IoMdArrowRoundBack } from "react-icons/io";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header/Header";
import { useAppDispatch, useAppSelector } from "../../redux/app/hooks";
import { useGetAllParkingSpaceLoByLatAndLangMutation } from "../../redux/services/parkingsApi";
import Loading from "../commons/Loading";
import Footer from "../../components/Footer/Footer";
import ParkingComponent from "../../components/ParkingComponent/ParkingComponent";
import { useSaveCustomerFavouriteMutation } from "../../redux/services/favouriteApi";
import { getParkingSpaces, setParkings } from "../../redux/slices/parkingSlice";
import {
  getIsLoggedInData,
  getLocation,
  setCurrentAddressData,
  setCurrentLocationData,
  setFromLocation,
  setLocationData,
  setTimeZone,
  setToLocation,
  setTypeName,
} from "../../redux/slices/navSlice";

function Cities() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location: any = useLocation();
  const currentUser: any = JSON.parse(localStorage.getItem("user") || "{}");
  const token: string = currentUser?.jwtToken;
  const userData: any = currentUser || {};

  const [fromcoords, setFromCoords] = useState<any>(null);
  const [locationData, setLocationData] = useState<any>(null);
  const cityId: string = location.state?.cityId || "";
  const cityName: string = location.state?.cityName || "";
  const [tripType, setTripType]: any = useState(location.state?.TripType || {});
  const checkIn: string = location.state?.checkIn || "";
  const checkOut: string = location.state?.checkOut || "";
  const selectedTZOptions: string = location.state?.selectedTZOptions || "";
  const packageTypeValue = location.state?.packageType || ""; 

  const [duration, distance] = packageTypeValue.match(/\d+/g) || [0, 0]


  const [saveCustomerFavourite] = useSaveCustomerFavouriteMutation();
  const [getAllParkingSpaceLoByLatAndLang, { data, isLoading, isSuccess, isError }] =
    useGetAllParkingSpaceLoByLatAndLangMutation();

  const parkingSpacesData = useAppSelector(getParkingSpaces);
  const [parkingSpaces, setParkingSpaces] = useState<any[]>([]);

  useEffect(() => {
    const fetchParkingSpaces = async () => {
      const payload = {
        offset: 5,
        page: 0,
        customerId: userData.id,
        checkInTime: checkIn,
        checkOutTime: checkOut,
        orderBy: "asc",
        columnName: "id",
        parkingTypeId: [tripType?.id],
        //parkingTypeId:"",
        seatingCapacity: location.state?.peopleCount,
        luggageCapacity: location.state?.luggageCount,
        cityId,
        selectedTZOptions,
        //duration:duration,
        //distance:distance,
      };
      await getAllParkingSpaceLoByLatAndLang({ payload });
    };

    fetchParkingSpaces();
  }, [cityId, userData.id, checkIn, checkOut, tripType, selectedTZOptions]);

  useEffect(() => {
    if (isSuccess && data) {
      console.log("API Data: ", data); 
      dispatch(setParkings(data));
      dispatch(setFromLocation(data?.address));
    } else if (isError) {
      console.error("Failed to fetch parking spaces.");
    }
  }, [isSuccess, isError, data, dispatch]);

  useEffect(() => {
    if (parkingSpacesData) {
      setParkingSpaces(parkingSpacesData);
    }
  }, [parkingSpacesData]);

  const toggleFavourites = (parking: any) => {
    const payload = {
      parkingLocationId: parking.id,
      customerId: currentUser?.customerId,
      status: !parking.isFavourite,
    };
    saveCustomerFavourite({ token, payload });
  };

  return (
    <div className="flex flex-col h-screen justify-between">
      <div className="h-[75px] z-10 fixed w-full px-10 flex items-center bg-white shadow-md">
        <Header position={"fixed"} isLoggedIn={!!token} />
      </div>

      {isLoading && <Loading />}

      <div className="mt-[120px] px-10 flex items-center justify-between">
        <h1 className="text-3xl font-bold text-[#2D3748]">{cityName} Cars</h1>
        <IoMdArrowRoundBack
          className="md:text-[40px] text-[30px] cursor-pointer"
          onClick={() => navigate("/")}
        />
      </div>

      <div className="pt-[20px] p-[20px] lg:px-[24px] my-[40px] md:mx-[13px] lg:mx-[60px] rounded-[16px] h-auto">
        <div className="lg:flex block justify-center lg:flex-wrap">
          {parkingSpaces && parkingSpaces.length > 0 ? (
            parkingSpaces.map((parking: any, index: number) => (
              <ParkingComponent
                key={index}
                type={parking?.parkingTypeResDTO?.typeName}
                data={parking}
                toggleFavourites={toggleFavourites}
                checkIn={checkIn}
                checkOut={checkOut}
                selectedTZOptions={selectedTZOptions}
                userLat={fromcoords?.lat}
                userLng={fromcoords?.lng}
                parkingLat={parking.latitude}
                parkingLng={parking.longitude}
                index={index}
                locationData={locationData}
                tripType={tripType}
                duration={duration}
                distance={distance}
              />
            ))
          ) : (
            <div className="text-center text-red-500 pt-2 md:flex h-[70%] w-full items-center justify-center">
              <h4 className="font-medium text-center p-4">
                {isLoading ? "Please wait... Loading" : "No Vehicle's available in this city !!"}
              </h4>
            </div>
          )}
        </div>
      </div>

      <div className="items-end">
        <Footer />
      </div>
    </div>
  );
}

export default Cities;
